import { create } from "zustand";

interface IAdSlotsState {
  seenCameras: string[];
  addSeenCamera: (id: string) => void;
}

export const useStreamateCamerasStore = create<IAdSlotsState>(
  (set) => ({
    seenCameras: [],
    addSeenCamera: (id: string) => set(({ seenCameras }) => ({
      seenCameras: [
        ...seenCameras.filter(item => item !== id),
        id
      ]
    })),
  }),
);
